//
// Multi - Checkbox
//
import React from 'react'
import PropTypes from 'prop-types'

import { Box, CTA, Flex, HR } from 'ui/acro'
import Boolean01 from './Boolean01'

const Select03 = ({ component, handleSelect, isSelected }) => {
  return (
    <Box mb={['24px', null, '30px']}>
      <HR />
      {component.prompt && (
        <CTA variant='heavy' color='primary' mt='14px'>
          {component.prompt}
        </CTA>
      )}
      <Flex
        id={`select-03-${component.prompt}`}
        flexDirection='column'
        flexWrap='wrap'
        maxHeight='300px' // Limit columns to 6 checkboxes
        maxWidth='100%'
        mt={['17px']}
      >
        {component.options &&
          component.options.map((option) => {
            const { prompt, slug } = option
            const selected = isSelected(option)
            const styleSelector = prompt.replace(/\s+/g, '-').toLowerCase()
            return (
              <Boolean01
                id={`boolean-01-${styleSelector}`}
                key={slug}
                handleSelect={() => handleSelect(option)}
                prompt={prompt}
                selected={selected}
                slug={slug}
                mb='16px'
              />
            )
          })}
      </Flex>
    </Box>
  )
}

Select03.propTypes = {
  component: PropTypes.object.isRequired,
  handleSelect: PropTypes.func.isRequired,
  selected: PropTypes.bool
}

export default Select03
